"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicPurchaseServiceV3 = void 0;
var tslib_1 = require("tslib");
var purchase_1 = require("./purchase");
var purchase_2 = require("@wix/wix-vod-gql-api/dist/src/public/purchase/purchase");
var PublicPurchaseServiceV3 = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PublicPurchaseServiceV3, _super);
    function PublicPurchaseServiceV3(authorization) {
        var _this = _super.call(this) || this;
        _this.purchaseService = new purchase_2.PurchaseService(authorization);
        return _this;
    }
    PublicPurchaseServiceV3.prototype.createOrder = function (videoId, channelId, paymentType, siteUrl, instance, compId) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                return [2 /*return*/, this.purchaseService.createOrder(videoId, channelId, paymentType)];
            });
        });
    };
    PublicPurchaseServiceV3.prototype.getPaymentStatus = function (videoId, channelId, orderId, transactionId, instance, paymentType) {
        return this.purchaseService.getOrderStatus(videoId, channelId, paymentType);
    };
    PublicPurchaseServiceV3.prototype.cancelOrder = function (channelId, siteUrl, instance) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.purchaseService.cancelOrder(channelId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PublicPurchaseServiceV3;
}(purchase_1.PublicPurchaseService));
exports.PublicPurchaseServiceV3 = PublicPurchaseServiceV3;
//# sourceMappingURL=purchase.v3.js.map